import { Component, OnInit, ViewChild} from '@angular/core';
import { Business } from '@core/model/business/business';
import { AuthService } from '@core/services/auth.service';
import { Country } from '@shared/model/country';
import { firstValueFrom, Observable } from 'rxjs';
import { BusinessService } from './pages/profile/services/business.service';
import { LocalStorageDataService } from '@core/services/local-storage.service';
import {SidebarComponent} from './sidebar/sidebar.component';

@Component({
  selector: 'app-layout',
  standalone: false,
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent implements OnInit  {
  @ViewChild('sidebar') sidebar!: SidebarComponent;
  sidebarOpen = false;
  business: Business;
  countries$: Observable<Country[]>;
  constructor(
    private authService: AuthService,
    public businessService: BusinessService,
    private localStorageService: LocalStorageDataService
  ){

  }

  ngOnInit(){
    this.initializeBusiness();
  }




  async initializeBusiness(): Promise<void> {
    const businessCountry = localStorage.getItem('countryCode');
    if (!businessCountry) {
      await this.fetchBusiness(this.authService.businessId);
      await this.fetchCountries();
    }
  }

  async fetchBusiness(businessId: string): Promise<void> {
    this.business = await firstValueFrom(this.businessService
      .getBusiness(businessId));
  }

  async fetchCountries(): Promise<void> {
    const countries = firstValueFrom(await this.localStorageService.getCountries$());
    const country = (await countries).find(
      (c) => c.isoCode === this.business?.country
    );
    if (country) {
      const currencyString = country?.currencyString;
      // Step 1: Parse JSON string
      const currencies = JSON.parse(currencyString);
      // Step 2: Access first item
      const code = currencies[0].Code;
      const symbol = currencies[0].Symbol;

      localStorage.setItem('country', country.isoCode);
      // Assuming timeZones is a string, update accordingly if it's an array or object.
      localStorage.setItem('timeZones', JSON.stringify(country.timezones));
      localStorage.setItem('currency', code);
      localStorage.setItem('currencySymbol', symbol);
    }

  }
  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;

    if (!this.sidebarOpen) {
      // alert('submenu close')
      this.sidebar.closeSubmenu();
    }
  }
  onSubmenuClosed() {
    this.sidebarOpen = false // Automatically toggles sidebar when submenu is closed
  }
}
